module.exports = __webpack_public_path__ + "static/media/Pop-Up-covid.3db5f1f3.png";